import { useLayoutEffect, useRef, type ReactNode } from 'react';
import {
    PANE_MOTION_EASING,
    PANE_MOTION_MS,
    prefersReducedMotion,
    type SlideDirection
} from './paneMotion';

const SLIDE_OFFSET_PX = 32;

// Animates its own mount only: the caller keys it per view, so each new view slides in once.
export function SlideStage({
    direction,
    children
}: {
    direction: SlideDirection;
    children: ReactNode;
}) {
    const stageRef = useRef<HTMLDivElement>(null);
    const mountDirection = useRef(direction);

    useLayoutEffect(() => {
        const stage = stageRef.current;
        const slide = mountDirection.current;
        if (!stage || slide === 'none' || typeof stage.animate !== 'function') return;
        if (prefersReducedMotion()) return;
        const from = slide === 'forward' ? SLIDE_OFFSET_PX : -SLIDE_OFFSET_PX;
        const animation = stage.animate(
            [
                { transform: `translateX(${from}px)`, opacity: 0 },
                { transform: 'translateX(0)', opacity: 1 }
            ],
            { duration: PANE_MOTION_MS, easing: PANE_MOTION_EASING }
        );
        return () => animation.cancel();
    }, []);

    return (
        <div ref={stageRef} className="flex min-h-0 flex-1 flex-col">
            {children}
        </div>
    );
}
